import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalOptions, NgbModalRef, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material';
import Swal from 'sweetalert2';
import { MainService } from '../main.service';

@Component({
  selector: 'app-admin-add-school',
  templateUrl: './admin-add-school.component.html',
  styleUrls: ['./admin-add-school.component.css']
})
export class AdminAddSchoolComponent implements OnInit {
 isLoading:boolean = false;
  closeResult: string;
  private modalRef: NgbModalRef;
  type:string ="";
  refcode:string ="";
  constructor(
    private modalService: NgbModal,
    private _snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private refService:MainService) { }

  ngOnInit() {
    
  }
  onOptionsSelected(event){
    this.refcode = "";
  }
  submitForm() {
    let req = {
      role:this.type
    }
    this.isLoading = true;
    this.refService.generate(req).subscribe(
      res => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.refcode =res.data.inviteCode;
        } else {
        }
        this.isLoading = false;
      },
      err => {
        this.isLoading = false;
      }
    );
  }
  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

}
